import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import classNames from 'classnames';
import config from '../../config';
import { logout } from '../../containers/Auth/actions';
import { detectByUrl, detectUserLanguage } from '../../utils/i18n';
import imgLogoBlack from '../../img/logo-black-green.png';
// translate
import messages from './messages';

const userLanguage = detectUserLanguage();
const urlLanguage = detectByUrl();

class Header extends Component {
  constructor(props) {
    super(props);

    this.onOutSideClick = this.onOutSideClick.bind(this);
    this.onShowLanguages = this.onShowLanguages.bind(this);
    this.onHeaderClick = this.onHeaderClick.bind(this);
    this.onInstrumentsMenu = this.onInstrumentsMenu.bind(this);

    this.state = {
      showLanguages: false,
      showMobileMenu: false,
      showInstrumentsMenu: false,
    };
  }

  componentWillMount() {
    document.addEventListener('click', this.onOutSideClick, false);
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.onOutSideClick, false);
  }

  onOutSideClick(e) {
    const { showLanguages, showInstrumentsMenu } = this.state;
    if (
      (showLanguages || showInstrumentsMenu) &&
      e.target.closest('.header-lang') === null
    ) {
      this.setState({
        showLanguages: false,
        showInstrumentsMenu: false,
      });
    }
  }

  onShowLanguages() {
    this.setState({
      showLanguages: !this.state.showLanguages,
    });
  }

  onHeaderClick() {
    this.setState({
      showMobileMenu: !this.state.showMobileMenu,
    });
  }

  onInstrumentsMenu() {
    this.setState({
      showInstrumentsMenu: !this.state.showInstrumentsMenu,
    });
  }

  languages() {
    const elements = [];
    config.languages.list.forEach((langTitle, langKey) => {
      elements.push(
        <li key={langTitle}>
          <a
            href={this.createUrlWithLanguage(langKey)}
            className={`${langKey} trans`}
            key={langTitle}
          >
            {langTitle}
          </a>
        </li>,
      );
    });

    return elements;
  }

  createUrlWithLanguage(langKey) {
    const { location } = this.props;
    const path = location.pathname;

    if (path === '/' || path === `/${urlLanguage}`) {
      return `/${langKey}`;
    }

    if (path.indexOf(`/${urlLanguage}/`) === -1) {
      return `/${langKey}${path}`;
    }

    return path.replace(`/${urlLanguage}/`, `/${langKey}/`);
  }

  render() {
    const { intl, dispatch, isFetching, isAuthenticated, user } = this.props;
    const { showLanguages, showMobileMenu, showInstrumentsMenu } = this.state;
    const langUrl = urlLanguage === null ? '' : `/${urlLanguage}`;

    return (
      <header className="container-fluid">
        <div className="row">
          <div
            className={classNames('header container', {
              active: showMobileMenu,
            })}
          >
            <div className="row">
              <div className="header-left col-xs-2 col-md-10">
                <div
                  className={classNames('header-lang', {
                    active: showLanguages && !showMobileMenu,
                  })}
                >
                  <Link
                    className={`header-lang-current ${userLanguage} trans`}
                    onClick={this.onShowLanguages}
                  />
                  <ul className="header-lang-select">
                    {this.languages()}
                  </ul>
                </div>

                {!isFetching &&
                  <ul className="header-nav">
                    <li>
                      <Link className="trans" to={`${langUrl}/rewards`}>
                        {intl.formatMessage(messages.rewards)}
                      </Link>
                    </li>
                    {isAuthenticated &&
                      <li>
                        <Link className="trans" to={`${langUrl}/dashboard`}>
                          {intl.formatMessage(messages.dashboard)}
                        </Link>
                      </li>}
                    {isAuthenticated &&
                      <li>
                        <Link className="trans" to={`${langUrl}/profile`}>
                          {intl.formatMessage(messages.profile)}
                        </Link>
                      </li>}
                    {isAuthenticated &&
                      user.member_id &&
                      <li>
                        <span>{intl.formatMessage(messages.membership)}</span>
                        <span>{user.member_id}</span>
                      </li>}
                    {isAuthenticated &&
                      <li
                        className={classNames('instruments-dropdown-wrap', {
                          active: showInstrumentsMenu,
                        })}
                      >
                        <Link
                          className="trans"
                          onClick={this.onInstrumentsMenu}
                        >
                          Instruments ▾
                        </Link>
                        <ul className="header-lang-select">
                          <li>
                            <a
                              href="//promo.art.art"
                              target="_blank"
                              rel="noopener noreferrer"
                              className="trans"
                            >
                              Promo
                            </a>
                          </li>
                          <li>
                            <a
                              href="//referral.art.art"
                              target="_blank"
                              rel="noopener noreferrer"
                              className="trans"
                            >
                              Referral
                            </a>
                          </li>
                          <li>
                            <a
                              href="//search.art.art"
                              target="_blank"
                              rel="noopener noreferrer"
                              className="trans"
                            >
                              Search
                            </a>
                          </li>
                        </ul>
                      </li>}
                    {isAuthenticated &&
                      <li>
                        <Link
                          className="trans logout"
                          to="/"
                          onClick={() => dispatch(logout())}
                        >
                          {intl.formatMessage(messages.logout)}
                        </Link>
                      </li>}
                    {!isAuthenticated &&
                      <li>
                        <Link className="trans" to="#signup">
                          {intl.formatMessage(messages.register)}
                        </Link>
                      </li>}
                    {!isAuthenticated &&
                      <li>
                        <Link className="trans" to="#login">
                          {intl.formatMessage(messages.login)}
                        </Link>
                      </li>}
                  </ul>}
              </div>

              <div className="header-right col-xs-10 col-md-2">
                <Link className="header-menu" onClick={this.onHeaderClick} />
                <Link className="header-logo" to="/">
                  <img
                    src={imgLogoBlack}
                    alt={intl.formatMessage(messages.logoAlt)}
                  />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </header>
    );
  }
}

Header.propTypes = {
  intl: intlShape.isRequired,
  dispatch: PropTypes.func.isRequired,
  isFetching: PropTypes.bool.isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
  user: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
};

function mapStateToProps(state) {
  return {
    isAuthenticated: state.get('auth').isAuthenticated,
    isFetching: state.get('auth').isFetching,
    user: state.get('auth').user,
  };
}

export default connect(mapStateToProps)(injectIntl(Header));



// WEBPACK FOOTER //
// ./src/containers/Header/index.js